import { css } from '@emotion/react';
import styled from '@emotion/styled';

const inlineContainer = `
  display: inline-block;
  width: max-content;
  float: right;
`;

const blockContainer = `
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

const FormButtonsContainer = styled.div<{
  withSeparator?: boolean;
  isInline?: boolean;
}>`
  ${({ isInline }) => (isInline ? inlineContainer : blockContainer)};
  align-items: center;
  border-top: ${({ withSeparator }) => withSeparator && '1px solid var(--border-primary)'};

  /* The settings frames close their cards a single spacing step under the last field (254:32132). */
  margin-top: var(--spacing-xs);
  padding-top: 0;

  /* The sibling spacing depends on the layout: the isInline variant is inline-block, where gap does
     nothing, so there the siblings are spaced directly. */
  ${(props: { isInline?: boolean }) =>
    props.isInline
      ? css`
          > * + * {
            margin-inline-start: var(--spacing-md);
          }
        `
      : css`
          gap: var(--spacing-md);
        `}
`;

export default FormButtonsContainer;
